import { externalApiUrl } from '@stores/atoms/url';
import { useAtomValue } from 'jotai';
import type { MouseEvent } from 'react';
import { Container, Help, Icon, Logo } from './style';

const Header = () => {
  const apiUrl = useAtomValue(externalApiUrl);

  const handleClickGuide = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    window.open(
      `${apiUrl}/envGuide`,
      '문제 해결 가이드',
      'toolbar=no,scrollbars=no,resizable=no,top=50,left=100,width=820,height=960',
    );
  };

  return (
    <Container>
      <Logo />
      <Help onClick={handleClickGuide} rel='noopener noreferrer'>
        <Icon />
      </Help>
    </Container>
  );
};

export default Header;
